<template>
	<div class="w-full">
		<vs-row class="mt-5" vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="8" vs-sm="12" class="text-left">
				<MinMaxValue :index="index"></MinMaxValue>
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left mt-5 md:mt-0">
				<Number v-model="questionsByPage[index].properties.default" :label="$t('MODULE.sliderValueInitial')" :min="minValue" :max="maxValue"></Number>
			</vs-col>
		</vs-row>

		<vs-row class="mt-5" vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
				<vs-input class="w-1/2" disabled  :label="$t('MODULE.sliderOrientation')" v-model="questionsByPage[index].properties.orientation"/>
			</vs-col>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="7" class="text-left mt-5 md:mt-0">
				<Color :index="index"></Color>
			</vs-col>
		</vs-row>

	</div>


</template>
<script type="text/javascript">
	import MinMaxValue from '../../componentsToQuestions/Min-Max-value.vue';
	import Number from '../../components/Number.vue';
	import Color from '../../componentsToQuestions/Color.vue';
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { MinMaxValue, Color, Number },
		computed: {
			...mapState('resource',['questionsByPage']),
            /**
             * Obtine el valor mínimo para el slider
             */
			minValue() {
				return this.questionsByPage[this.index].properties.minValue;
			},
            /**
             * Obtiene le valor máximo del slider
             */
			maxValue() {
				return this.questionsByPage[this.index].properties.maxValue;
			}
		}
	}

</script>
